import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { HiChevronRight } from "react-icons/hi2";

function PerformanceSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let hasAppeared = false;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (!hasAppeared) {
            setShouldAnimate(true);
            hasAppeared = true;
          }
          setVisible(true);
        } else {
          setVisible(false);
          hasAppeared = false;
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const handleNavigate = (title) => {
    navigate(`/service/${encodeURIComponent(title)}`);
  };

  const services = [
    {
      title: "セールスプロモーション",
      description: `商品のブランディングや販促ツール制作、現場での実行支援まで
      トータルで対応し売上を加速。`,
    },    
    {
      title: "広告代理店",
      description: `クライアントの事業成長を支える最適な広告戦略を企画・提案します。
      マスメディアからデジタル広告まで幅広く対応。`,
    },
    {
      title: "イベント企画運営",
      description: `展示会・セミナー・販促イベント・配信イベントなど
      企画から運営までトータルでサポート。`,
    },
    {
      title: "ダイレクトマーケティング",
      description: `顧客データを活用した精密なターゲティングで
      ROIを最大化するキャンペーンを展開。`,
    },
    {
      title: "ウェルケア事業部",
      description: `介護・福祉業界に特化したサービスを提供。
      施設運営支援から人材育成まで幅広くサポート。`,
    },    
  ];

  return (
    <section
      id="performance"
      ref={ref}
      className={`backdrop-blur-md rounded-3xl p-6 md:p-12 shadow-2xl border border-cyan-200/10 hover:border-cyan-300/30 mb-16 max-w-5xl mx-auto ${visible ? "opacity-100" : "opacity-0"
        }`}
      style={{
        willChange: "opacity",
        transition: shouldAnimate
          ? "opacity 1.2s cubic-bezier(.4,0,.2,1)"
          : "none",
      }}
      onTransitionEnd={() => setShouldAnimate(false)}
    >
      <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight border-b border-cyan-400/30 pb-2 mb-8">
        Service
      </h2>
      <div className="flex flex-col gap-4">
        {services.map((service, index) => (
          <div
            key={index}
            className="relative cursor-pointer bg-gradient-to-r bg-gray-700/60 rounded-xl px-6 py-4 shadow-md border border-cyan-400/20
              transition duration-300 ease-in-out hover:scale-[1.01] hover:from-cyan-800 hover:to-orange-800 hover:shadow-lg"
            onClick={() => setExpanded(expanded === index ? null : index)}
          >
            {/* タイトル（常時表示） */}
            <div className="flex items-center justify-between">
              <div className="text-xl md:text-2xl font-extrabold text-orange-500">
                {service.title}
              </div>
              <motion.div
                animate={{ rotate: expanded === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="text-white text-xl"
              >
                <HiChevronRight />
              </motion.div>
            </div>

            {/* 展開時のみ表示 */}
            <AnimatePresence>
              {expanded === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  className="mt-3 overflow-hidden origin-top"
                >
                  <div className="text-base md:text-lg text-blue-100 mb-3 text-left">
                    {service.description}
                  </div>
                  <div
                    role="button"
                    tabIndex={0}
                    className="mt-2 inline-block"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNavigate(service.title);
                    }}
                  >
                    <span
                      className="inline-block text-sm md:text-base font-bold text-white px-4 py-1 rounded-full border border-white
                        transition-all duration-300 hover:bg-white hover:text-black hover:shadow-md"
                    >
                      MORE ＞
                    </span>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

          </div>
        ))}
      </div>
    </section>
  );
}

export default PerformanceSection;